export default __webpack_public_path__ + "static/media/policy09_2023.f20a8698.jpg";